export default __webpack_public_path__ + "static/media/concrete-wall.26941afe.png";